export const safeDisposeViz = (viz) => {
  if (!viz) return;
  try {
    if (typeof viz.dispose === 'function') {
      viz.dispose();
    } else if (typeof viz.remove === 'function') {
      viz.remove();
    }
  } catch (error) {
    console.error('Error disposing viz:', error);
  }
};
